import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptBotEvalCriteriaAPI from '../../api/wgpt/botEvalCriteria';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isSeeding: false,
  },
};

export const getters = {
  getCriteria($state) {
    return $state.records;
  },
  getCriterion: $state => id => {
    return $state.records.find(record => record.id === Number(id)) ?? {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, botId) => {
    commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isFetching: true });
    try {
      const { data } = await new WgptBotEvalCriteriaAPI(botId).get();
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isFetching: false });
    }
    return null;
  },
  create: async ({ commit }, { botId, ...createObj }) => {
    commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isCreating: true });
    try {
      const { data } = await new WgptBotEvalCriteriaAPI(botId).create(
        createObj
      );
      commit(types.ADD_WGPT_BOT_EVAL_CRITERION, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isCreating: false });
    }
    return null;
  },
  update: async ({ commit }, { botId, id, ...updateObj }) => {
    commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await new WgptBotEvalCriteriaAPI(botId).update(
        id,
        updateObj
      );
      commit(types.EDIT_WGPT_BOT_EVAL_CRITERION, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isUpdating: false });
    }
    return null;
  },
  delete: async ({ commit }, { botId, id }) => {
    commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isDeleting: true });
    try {
      await new WgptBotEvalCriteriaAPI(botId).delete(id);
      commit(types.DELETE_WGPT_BOT_EVAL_CRITERION, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isDeleting: false });
    }
    return null;
  },
  seed: async ({ commit }, botId) => {
    commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isSeeding: true });
    try {
      const { data } = await new WgptBotEvalCriteriaAPI(botId).seed();
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG, { isSeeding: false });
    }
    return null;
  },
};

export const mutations = {
  [types.SET_WGPT_BOT_EVAL_CRITERIA_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_BOT_EVAL_CRITERIA]: MutationHelpers.set,
  [types.ADD_WGPT_BOT_EVAL_CRITERION]: MutationHelpers.setSingleRecord,
  [types.EDIT_WGPT_BOT_EVAL_CRITERION]: MutationHelpers.update,
  [types.DELETE_WGPT_BOT_EVAL_CRITERION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
